module.exports = __webpack_public_path__ + "static/media/cupones.50c33be9.webp";